import React, { FC } from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import Icon from '../../../../@shared/icon';
import RoutableNotEditableLink from '../../../../@shared/routableNotEditableLink';

const DealerLocatorAttribute: FC<{ iconName: string; attribute: string; href: string; hasUnderline: boolean; openInNewTab?: boolean }> = (props) => {
  const { iconName, attribute, href, hasUnderline, openInNewTab=false } = props;
  return (
    <RoutableNotEditableLink
      target={openInNewTab ? '_blank' : ''}
      className={`dealer-locator-detail__contacts__attributes ${
        hasUnderline && 'dealer-locator-detail__contacts__attributes--has-underline'
      }`}
      href={href}
    >
      <Icon iconName={iconName} color={'primary'} size={24} />
      <Text field={{ value: attribute }} tag="p" />
    </RoutableNotEditableLink>
  );
};

export default DealerLocatorAttribute;
